const JWT_TOKEN = "x-token";

export default {
  JWT_TOKEN,
};
